<template>
  <v-container style="height: 100%">
    <v-row style="height: 100%">
      <v-col class="d-flex justify-center align-center">
        <v-sheet elevation="8" class="pa-8" rounded width="400">
          <h2 class="text-center mb-5">プロファイル編集</h2>
          <v-form
              ref="editProfileForm"
              v-model="editProfileFormValid"
              lazy-validation
          >
            <p>メール：{{ profile.email }}</p>
            <v-text-field
                hide-details="auto"
                label="性*"
                type="text"
                required
                :rules="[(v) => (!!v && !!v.trim()) || '名字を入力してください。']"
                outlined
                clearable
                dense
                v-model="profile.lastName"
            ></v-text-field>
            <v-text-field
                hide-details="auto"
                label="名*"
                type="text"
                required
                :rules="[(v) => (!!v && !!v.trim()) || '名前を入力してください。']"
                outlined
                clearable
                dense
                v-model="profile.firstName"
            ></v-text-field>
          </v-form>
          <v-btn
              class="mt-4"
              style="width:100%;"
              depressed color="primary"
              @click="changeProfile()"
          >
            編集
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {store} from "@/store";

export default {
  name: "ProfileEdit",
  data() {
    return {
      editProfileFormValid: null,
      profile: {
        firstName: null,
        lastName: null,
        email: null
      }
    }
  },

  methods: {
    changeProfile(){
      if (this.$refs.editProfileForm.validate()) {
        this.axios
            .put('/api/profile/' + store.state.email + '/edit/', {profile: this.profile})
            .then(() => {
              store.showSuccessDialog('プロファイル編集完了しました。ホームページに遷移します。',
                  () => {this.$router.push('/dashboard');})
            })
            .catch(() => {
              store.showErrorDialog('エラーが発生しました。再度試してください。');
            })
      }
    }
  },

  created() {
    this.axios
        .get('/api/profile/' + store.state.email)
        .then((response) => {
          this.profile.firstName = response.data.first_name;
          this.profile.lastName = response.data.last_name;
          this.profile.email = response.data.email;
        })
  }
}
</script>

<style scoped>

</style>
